export const blogData = [
    {
        id: 1,
        title: 'Computer Security & Best Practices',
        description: 'Here we talked about Computer Security and General Cyber Security and its Concepts.',
        date: 'Aug 15, 2022',
        image: 'https://res.cloudinary.com/practicaldev/image/fetch/s--z6zLzmvP--/c_limit%2Cf_auto%2Cfl_progressive%2Cq_auto%2Cw_880/https://dev-to-uploads.s3.amazonaws.com/uploads/articles/oo7xmjtayw72fg1nzwn8.png',
        url: 'https://dev.to/aliahad002/computer-security-best-practices-50j2'
    },
    {
        id: 2,
        title: 'CHECK WEATHER FROM TERMINAL USING WTTR.IN',
        description: 'wttr.in is a console-oriented weather forecast service that supports various information representation methods like ANSI-sequences for console HTTP clients, HTML, or PNG.',
        date: 'Aug 11, 2020',
        image: 'https://1.bp.blogspot.com/-OW7jX57tea4/XvnGxuEOslI/AAAAAAAABW0/R8lVT1AXDSwnvE0EGA9Ra49-LDm1ACwDgCK4BGAsYHg/s1216/wttr1.png',
        url: 'https://medium.com/@aliahad002'
    },
    {
        id: 3,
        title: 'SIEM VS SOC & HOW SIEM WORKS!!',
        description: 'Here are some basics of how SIEM works and difference between SIEM & SOC. :)',
        date: 'Sep 9, 2022',
        image: 'https://miro.medium.com/max/1050/1*eKO1nQcpLA2ew8vJ1RdvWQ.jpeg',
        url: 'https://medium.com/@aliahad002/siem-vs-soc-how-siem-works-79aff681d66e'
    },
    {
        id: 4,
        title: 'CHECK INTERNET SPEED FROM THE COMMAND LINE',
        description: 'Want to check your internet speed from the terminal? Here\'s the perfect way to the that.',
        date: 'Sep 17, 2020',
        image: 'https://1.bp.blogspot.com/-XTVMsZP3HaM/Xxpl394txlI/AAAAAAAABws/zovXWiuNGg4TzBwYYVFfJ1ixDb3JfVokgCNcBGAsYHQ/w400-h195/speedtest.png',
        url: 'https://medium.com/@aliahad002'
    },
    {
        id: 5,
        title: 'GET MICHAEL\'S OR TREVOR\'S VEHICLES FULLY UPGRADED IN GTA V FOR FREE',
        description: 'In case you haven\'t heard of this game, GTA stands for \'Grand Theft Auto\'. It is an open-world game published by Rockstar Games.',
        date: 'Oct 1, 2020',
        image: 'https://1.bp.blogspot.com/-jhdtUBIRD_s/XxLFKQuRz9I/AAAAAAAABsM/mClfbfDFKvsUwA7Wyi25Lzu3DEmL2lxrACNcBGAsYHQ/s1919/gta.jpg',
        url: 'https://medium.com/@aliahad002'
    },
]




// Do not remove any fields.
// Leave it blank instead as shown below.


/* 
{
    id: 1,
    title: 'Car Pooling System',
    description: '',
    date: 'Oct 1, 2020',
    image: '',
    url: 'https://preview.colorlib.com/theme/rezume/'
}, 
*/